import React, { PureComponent } from "react";
import Clickable from '../Clickable/Clickable.js';

import './Board.css';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faRedoAlt, faFilm, faLongArrowRight, faLightbulb, faArrowToLeft } from '@fortawesome/pro-solid-svg-icons'
library.add(faBars, faRedoAlt, faFilm, faLongArrowRight, faLightbulb, faArrowToLeft);

class BoardButton extends PureComponent {
    render() {

        let rotations = this.props.rotations || 0;

        return (
            <div
                style={{
                    position: 'relative',
                    margin: '0 5px',
                    opacity: (this.props.showing ? '1' : '0'),
                    pointerEvents: (this.props.showing ? 'auto' : 'none'),
                    float: this.props.float,
                    transform: 'translateY(' + (this.props.showing ? '0' : '20px') + ')',
                    transition: 'opacity 200ms, transform 200ms',
                }}
            >
                <Clickable
                    onClick={() => {
                        if (typeof this.props.onClick === 'function') {
                            this.props.onClick();
                        }
                    }}
                >
                    <div
                        style={{
                            position: 'relative',
                            padding: '9px 25px',
                            borderRadius: '8px',
                            color: '#130f40',
                            backgroundColor: '#fff',
                            boxShadow: '0 3px 0px rgba(0,0,0,0.10)',
                            border: '1px solid rgba(0,0,0,0.10)',
                            fontSize: '14px',
                            animation: (this.props.pulsing ? 'pulse 3000ms linear ' + (this.props.pulseIndefinitely ? 'infinite' : '1') : 'none'),
                            transition: 'box-shadow 200ms',
                        }}
                    >
                        <div
                            style={{
                                position: 'relative',
                                transform: 'rotate(' + (rotations * 360) + 'deg)',
                                transition: 'transform 1000ms',
                            }}
                        >
                        {this.props.children}
                        </div>
                    </div>
                </Clickable>
            </div>
        );
    }
}

class BoardButtons extends PureComponent {
    render() {
        return (
            <div
                className="BoardButtonsWrapper"
                style={{
                    position: 'absolute',
                    bottom: '0',
                    width: '100%',
                    boxSizing: 'border-box',
                }}
            >
                <div
                    style={{
                        position: 'relative',
                        boxSizing: 'border-box',
                    }}
                >
                    <div
                        style={{
                            position: 'relative',
                            overflow: 'auto',
                            padding: '20px 20px',
                            height: 'auto',
                            display: 'block',
                        }}
                    >
                        <BoardButton
                            showing={this.props.showingMenu}
                            float={'left'}
                            onClick={() => {
                                if (typeof this.props.onShowMenu === 'function') {
                                    this.props.onShowMenu();
                                }
                            }}
                        >
                            <FontAwesomeIcon icon={faBars} />
                        </BoardButton>
                        <BoardButton
                            showing={this.props.showingRestart}
                            float={'right'}
                            pulsing={this.props.pulsingRestart}
                            pulseIndefinitely={true}
                            rotations={this.props.restartRotations}
                            onClick={() => {
                                if (typeof this.props.onRestart === 'function') {
                                    this.props.onRestart();
                                }
                            }}
                        >
                            <FontAwesomeIcon icon={faRedoAlt} />
                        </BoardButton>
                        <BoardButton
                            showing={this.props.showingHint}
                            float={'right'}
                            pulsing={this.props.pulsingHint}
                            pulseIndefinitely={false}
                            onClick={() => {
                                if (typeof this.props.onUseHint === 'function') {
                                    this.props.onUseHint();
                                }
                            }}
                        >
                            <FontAwesomeIcon style={{ marginRight: '15px', }} icon={faFilm} />
                            <FontAwesomeIcon style={{ marginRight: '15px', opacity: 0.7, }} icon={faLongArrowRight} />
                            <FontAwesomeIcon icon={faLightbulb} />
                        </BoardButton>
                    </div>
                </div>
            </div>
        );
    }
}

export default BoardButtons;
